import {
  observable,
  runInAction,
  toJS,
  reaction,
  action,
  computed,
  autorun
} from 'mobx';
import { ViewBase } from 'mutants-appfx';
import { PosInitData, PosSetData } from 'tplus-poslogin';
import siderLeftVM from './SiderLeft';
import _cloneDeep from 'lodash/cloneDeep';
import { voucherStateStore } from '../pageStores';

import { localStore as storeUtil } from 'mutants-util';


const stateDefault = {
  visible: true,
  enable: true,
  tip: ''
}
class Operations extends ViewBase {
  get type() {
    return 'Operations';
  }

  @observable bottomOperations = [];
  @observable uiStateUpdate = [];

  @computed get operations() {
    var that = this;
    return this.bottomOperations.map(el => {
      const updateObj = that.uiStateUpdate.find(update => {
        return el.Name == update.name;
      }) || {};
      let uiState = { ...stateDefault, ...updateObj }
      return {
        ...el,
        uiState
      }
    })
  }

  @computed get menu() {
    var data, length;
    if (this.store && this.store.getViewItem) {
      data = this.store.getViewItem('Voucher').data;
    }
    length = data && data.length || 0;
    let menu = _cloneDeep(toJS(this.validMenu));
    /* 挂单&解挂 */
    menu = menu.filter((el) => {
      if (el.key === 'list' && !length) return false;
      if (el.key === 'list2' && length) return false;
      return true;
    })
    /* 超出menu最大数量进入更多 */
    let moreBar = menu.splice(menu.length - 1, 1)[0]
    let menus;
    if (menu.length > this.leftMenuCounts) {
      menus = menu.splice(0, this.leftMenuCounts - 1);
      moreBar.subs = [...menu]
      menus.push(moreBar)
    } else {
      menus = menu;
    }
    return menus
  }

  leftOperations = [];
  @observable validMenu = [];//左侧菜单全集
  leftMenuCounts = 7;

  constructor(store, name, operations = []) {
    super(store, name);
    let operationsButtomObj = [];
    let leftOperations = [];


    operations.forEach((operation) => {
      if (operation.Position.indexOf('bottom') > -1) {
        operationsButtomObj[operation.TabIndex] = operation;
      } else {
        leftOperations.push(operation);
      }
    });

    //底部菜单生成
    runInAction(() => {
      for (let i = 0; i < operationsButtomObj.length; i++) {
        if (operationsButtomObj[i] !== undefined) this.bottomOperations.push(operationsButtomObj[i]);
      }
      /* 启用u会员，去掉u会员才能称重的判断 */
      // const isEnableUMember = PosInitData('IsEnableUMember');
      // if (!isEnableUMember) {
      //   this.bottomOperations = this.bottomOperations.filter((el) => el.Name !== 'Balance')
      // }
    })
    /* 获取练习模式下的参数 */
    if (voucherStateStore) voucherStateStore.init();
    /* 左侧菜单生成 */
    this.leftOperations = leftOperations;
    console.log('leftOperations===', leftOperations)
    this.validMenu = _cloneDeep(siderLeftVM);
    this.filterLeft();
  }

  @action changeMenu = (num) => {
    const items = this.validMenu;
    items && items.map(item => {
      if (item.isTotal == true) {
        item.totalNum = num;
        let arrs = item.subs;
        arrs && arrs.length > 0 && arrs.map(v => {
          if (v.isTotal == true) {
            v.totalNum = num;
          }
        })
      }
    })
  }

  @action changeUiState(...update) {
    let that = this;
    const length = that.uiStateUpdate.length;
    that.uiStateUpdate.splice(0, length)
    update.forEach(({ name, state = {} }) => {
      that.uiStateUpdate.push({ name, ...state })
    })
  }

  @action clearUiState() {
    const length = this.uiStateUpdate.length;
    this.uiStateUpdate.splice(0, length);
  }

  filterLeft = () => {
    this.filterMenuList();
    this.permissionControl();
  }

  /* 整理左侧菜单Tree结构，方便展示
   * 例如：同时存在自提、配送时，就要显示一级菜单电商；假如只有自提或配送时，就以一级菜单展示
  */
  filterMenuList = () => {
    let validMenu = this.validMenu;
    // /* 启用会员模块 */
    const isEnableMember = PosInitData('isEnableMember');
    if (!isEnableMember) {
      validMenu = validMenu.filter((el) => el.key !== 'member')
    }
    /* 电商模块判断 */
    const isEnableUMember = PosInitData('IsEnableUMember'); //是否U会员
    const isCommerce = PosInitData('ECommerce'); //是否开启电商
    const isMain = PosInitData('IsMain'); //是否主POS
    const isControlMeiTuan = !!PosInitData('ControlMeiTuan');//是否阻止电商开启

    let arr = [];
    if (isCommerce) {
      for (let item of validMenu) {
        if (isMain && isEnableUMember) {
          if (item.key == 'online') {
            item.subs = [...validMenu.filter(v => v.key == 'takeTheir' || v.key == 'delivery')]
          }
          if (item.key == 'takeTheir' || item.key == 'delivery') {
            continue;
          }
        } else {
          if (item.key == 'takeTheir' && !isEnableUMember) {
            continue;
          }
          if (item.key == 'delivery' && (isControlMeiTuan || !isMain)) {
            continue;
          }
        }
        arr.push(item);
      }
    } else {
      arr = validMenu.filter(el => {
        if (el.key == 'online' || (el.key == 'takeTheir' && !isEnableUMember) || (el.key == 'delivery' && (isControlMeiTuan || !isMain))) {
          return false;
        }
        return true;
      })
    }
    this.validMenu = arr;
  }

  /* menus 权限控制 */
  permissionControl() {
    const map = this.createPermissionObj();
    this.filterMenu(this.validMenu, map)
  }

  /* 权限对象 */
  createPermissionObj() {
    //选项“必须原单退货”权限判断。
    let isMustReturnByOrig = PosInitData('isMustReturnByOrig');
    const isCommerce = PosInitData('ECommerce') && !PosInitData('ControlMeiTuan'); //是否开启电商
    var map = {
      'home': 'Quit',
      'refund': true,
      'refundCurrent': 'ReturnInventoy',
      'refundBefore': 'ReturnInventoy',
      'list': 'PendingVoucher',
      'list2': 'PendingVoucher',
      'member': true,
      'memberManager': 'MemberSearch',
      'memberAdd': 'MemberAdd',
      'search': true,
      'searchbill': 'VoucherSearch',
      'searchstock': 'StockSearch',
      "online": "online",
      'takeTheir': 'Deliver',
      "delivery": 'Delivery',
      'cashbox': 'OpenBox',
      'lock': 'Lock',
      'quickKey': true,
      'more': true
    }
    for (let key in map) {
      const name = map[key];
      if (name !== true) {
        if (!!this.leftOperations.find(el => el.Name === name)) {
          if (key == 'refundCurrent' && isMustReturnByOrig == '1') {//对“原单退货”权限判断
            map[key] = false;
          } else {
            map[key] = true;
          }
          // 练习模式
          if (voucherStateStore.mode === 'practice' && ['memberAdd', 'takeTheir', 'delivery'].indexOf(key) > -1) {
            map[key] = false;
          }
        } else {
          if (key == 'online' && isCommerce && voucherStateStore.mode !== 'practice') {
            map[key] = true;
          } else {
            map[key] = false;
          }
        }
      }
    }
    //pad 去除快捷键
    map['quickKey'] = !(storeUtil.get('isHorizontalPad') == 'true')

    console.log('map=========', JSON.stringify(map));
    return map;
  }

  /* 删除没有权限的menu */
  filterMenu(menus, map) {
    let length = menus.length;
    for (var index = length - 1; index >= 0; index--) {
      let el = menus[index];
      if (el.subs) {//带有子节点
        el.subs = this.filterMenu(el.subs, map);
        if (!el.subs.length && el.key != 'more') {
          menus.splice(index, 1);
        }
      } else {
        if (!map[el.key]) {
          menus.splice(index, 1);
        }
      }
    }
    return menus;
  }

  /* 生成视图模型 */
  createMenu = () => {
    reaction(() => {
      var data;
      if (this.store && this.store.getViewItem) {
        data = this.store.getViewItem('Voucher').data;
      }
      return data && data.length || 0;
    }, (length) => {
      let menu = _cloneDeep(this.validMenu);
      /* 挂单&解挂 */
      menu = menu.filter((el) => {
        if (el.key === 'list' && !length) return false;
        if (el.key === 'list2' && length) return false;
        return true;
      })
      /* 超出menu最大数量进入更多 */
      let moreBar = menu.splice(menu.length - 1, 1)[0]
      if (menu.length > this.leftMenuCounts - 1) {
        const moreBarSubs = menu.splice(this.leftMenuCounts - 1);
        moreBar.subs = [...moreBar.subs, ...moreBarSubs]
      }
      if (moreBar.subs && !!moreBar.subs.length) {
        menu.push(moreBar);
      }
      this.menu = menu;

    }, {
      fireImmediately: true
    })
  }

  static fromJS(store, { Operations: operations = [] }) {
    PosSetData({ Operations: operations.map(operation => operation.Name) });
    return new Operations(store, 'Operations', operations)
  }
}
export default Operations;
